import React, { useState, useEffect, useRef } from 'react';
import './AdminHeader.css';
import img from '../../static/img/vm/vm-logo-wordmark.png';
import mobile from '../../static/img/vm/vm-logo-triad.svg';
import { useNavigate } from 'react-router-dom';

import { logout } from '../../actions/UserManagement';

interface AdminHeaderProps {
    isCollapsed: boolean;
    setIsCollapsed: (collapsed: boolean) => void;
    user: any;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ isCollapsed, setIsCollapsed, user }) => {
    const handleToggle = () => {
        setIsCollapsed(!isCollapsed);
    };

    const navigate = useNavigate();

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const toggleDropdown = () => {
        setIsDropdownOpen((prev) => !prev);
    };

    if (user === null || user === undefined) {
        navigate('/login');
    }

    const handleViewProfile = () => {
        navigate('/view-user', { state: { user: user } });
    };

    const handleLogout = () => {
        logout()
            .then(response => {
                if (response.data.success) {
                    navigate('/');
                } else {
                    console.error('Logout failed:', response.data.message);
                }
            })
            .catch(error => {
                console.error('Logout error:', error);
            });
    };

    // Detect clicks outside of dropdown
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsDropdownOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className={`admin-header ${isCollapsed ? 'collapsed' : 'expanded'}`} >
            <div
            className="menu-icon"
            onClick={handleToggle}
        >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                strokeWidth={1.5} stroke="currentColor" className="icon">
                <path strokeLinecap="round" strokeLinejoin="round"
                    d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
            </svg>
        </div>
            {/* Center: Logo */}
            <div className="header-center">
                {window.innerWidth > 568 ? <img src={img} alt="VM Logo" className="header-logo" /> : <img src={mobile} alt="VM Logo" className="header-logo" />}

            </div>

            {/* Right: User Menu */}
            {window.innerWidth > 568 ? <div className="user-menu" ref={dropdownRef}>
                <div className="user-trigger" onClick={toggleDropdown}>
                    <div style={{ width: '25px', height: '25px'}}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            strokeWidth={1.5} stroke="currentColor" className="icon" style={{width: '25px', height: '25px'}}>
                            <path strokeLinecap="round" strokeLinejoin="round"
                                d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                        </svg>
                    </div>
                    <span className="user-name">{user.name}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon" style={{width: '25px', height: '25px'}} fill="none" viewBox="0 0 24 24"
                        strokeWidth={1.5} stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                </div>

                {isDropdownOpen && (
                    <div className="dropdown-menu">
                        <div className="dropdown-item" onClick={handleViewProfile}>View Profile</div>
                        <div className="dropdown-item" onClick={handleLogout}>Logout</div>
                    </div>
                )}
            </div> :
            <div className="user-menu" ref={dropdownRef}>
            <div className="user-trigger" onClick={toggleDropdown}>
                {/* <div style={{ width: '25px', height: '25px'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        strokeWidth={1.5} stroke="currentColor" className="icon" style={{width: '25px', height: '25px'}}>
                        <path strokeLinecap="round" strokeLinejoin="round"
                            d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    </svg>
                </div> */}
                <svg xmlns="http://www.w3.org/2000/svg" className="icon" style={{width: '25px', height: '25px'}} fill="none" viewBox="0 0 24 24"
                        strokeWidth={1.5} stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>

            </div>

            {isDropdownOpen && (
                <div className="dropdown-menu">
                    <div className="dropdown-item" onClick={handleViewProfile}>View Profile</div>
                    <div className="dropdown-item" onClick={handleLogout}>Logout</div>
                </div>
            )}
        </div>
            }

        </div>
    );
};

export default AdminHeader;
